import * as constType from '@js/constants/actionsTypes';
import {
  getCouponListJSON, // 获取折扣卷
} from './testJsonApi';

const couponMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case 'GET_UPDATE_COUPON_LIST_DATA': {
      const data = {
        page: '1',
        type: 'unused',
      };
      getCouponListJSON('get', data).then((res) => {
        if (JSON.stringify(res) !== '{}') {
          const rtnObj = res.data.data;
          store.dispatch({ type: constType.UPDATE_COUPON_LIST_DATA, payload: rtnObj });
        }
      }).catch((err) => {
        if (err.status === '405') {
          alert('很抱歉，您閒置已久將重新整理頁面，請稍後再重新操作');
          window.location.reload();
        } else {
          alert('很抱歉！目前系統忙碌中，請稍候再試。');
        }
        // store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
      });

      return next(action);
    }

    default:
      return next(action);
  }
};

export default couponMiddleware;
